/* eslint-disable no-sparse-arrays */
import React, { useState, useCallback, useMemo } from 'react'
import {
  Box,
  Drawer,
  HeaderTertiary,
  List,
  ListItem,
  ListItemButton,
  Button,
  GameButton
} from '@fedsim/components'
import { useNavigate } from 'react-router-dom'
import { routesList } from 'constants/routes'
import { trackEv, Categories, Actions } from 'analytics'

export const anchor = 'right'

export function LayoutDrawer() {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const closeDrawer = () => setOpen(false)
  const toggleDrawer = useCallback(() => setOpen(!open), [open])
  const nav = useMemo(() => path => {
    // !sticky &&
    trackEv(Categories.Sidebar, Actions.Navigate, { label: path })

    toggleDrawer()
    navigate(path)
  }, [navigate, toggleDrawer])
  const tools = [
    {
      title: 'The Office',
      onClick: () => nav(routesList.OFFICE.path)
    },
    {
      title: 'Draft',
      onClick: () => nav(routesList.DRAFT.path.replace('/*', '/start'))
    },
    {
      title: 'Alignment',
      onClick: () => nav(routesList.ALIGNMENT.path)
    },
    {
      title: 'Simulate',
      onClick: () => nav(routesList.SIMULATE.path)
    },
    {
      title: 'Feuds',
      onClick: () => nav(routesList.FEUDS_PLANNER.path)
    },
    {
      title: 'Reigns',
      onClick: () => nav(routesList.REIGNS.path)
    },
    {
      title: 'Arenas',
      onClick: () => nav(routesList.ARENAS.path)
    }
  ]
  const create = [
    {
      title: 'Create a production',
      onClick: () => nav('/production/create')
    },
    {
      title: 'Create a tournament',
      onClick: () => nav('/tournaments')
    },
    {
      title: 'Create a match',
      onClick: () => nav(routesList.MATCH.path.replace('/*', ''))
    },
  ]
  const cms = [
    {
      title: 'CMS',
      onClick: () => nav('/dashboard')
    },
  ]

  const settings = [
    ...cms,
    {
      title: 'Setup',
      onClick: () => nav(routesList.SETUP.path.replace('/*', '/setup'))
    },
    {
      title: 'Blog',
      onClick: () => nav(routesList.BLOG.path.replace('/*', '/blog'))
    },
    {
      title: 'Migrations',
      onClick: () => nav(routesList.MIGRATIONS.path.replace('/*', '/migrations'))
    },
    {
      title: 'Settings',
      onClick: () => nav(routesList.SETTINGS.path)
    },
    {
      title: 'Help',
      onClick: () => nav(routesList.HELP.path)
    }
  ]

  const options = [
    {
      title: 'Tools',
      collection: tools,
    },
    {
      title: 'Create',
      collection: create,
    },
    {
      title: 'Settings',
      collection: settings,
    },
  ]

  return (
    <Box>
      <Button
        sx={{
          color: 'white',
          backgroundColor: 'black',
          boxShadow: 'none',
          borderColor: '#666',
          '&:hover': {
            backgroundColor: 'black',
            boxShadow: 'none',
            borderColor: '#ccc',
          },
        }}
        aria-controls="positioned-menu"
        aria-haspopup="true"
        variant="outlined"
        color="secondary"
        fullWidth
        onClick={toggleDrawer}
      >
        Menu
      </Button>
      <Drawer
        anchor={anchor}
        open={open}
        onClose={closeDrawer}
      >
        <Box
          role="presentation"
          sx={{
            top: 100,
            width: {
              xs: '100%',
              sm: 300,
            }
          }}
        >
          <Box sx={{
            marginTop: -1,
            p: 0,
          }}>
            <List component="nav" dense>
              {options.map((item, index) => {
                return (
                  <ListItem key={`${index}-${item.title}`}
                    disablePadding
                    sx={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                      p: 0,
                      m: 0,
                    }}>
                    <Box sx={{
                      backgroundColor: theme => theme.palette.primary.contrastText,
                      color: 'white',
                      p: 1,
                      m: 0,
                      width: "100%"
                    }}>
                      <HeaderTertiary>{item.title}</HeaderTertiary>
                    </Box>
                    <List dense component="nav" sx={{
                      width: "100%"
                    }}>
                      {item?.collection?.map((item, index) => (
                        <ListItem
                          key={index}
                          sx={{
                            width: "100%",
                            p: 0,
                            m: 0,
                          }}>
                          <ListItemButton key={item.title} onClick={item.onClick} sx={{
                            lineHeight: 1.1,
                            p: 1.3,
                            m: 0,
                            mb: 0.3,
                            width: "100%"
                          }}>
                            {item.title}
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  </ListItem>
                )
              })}
            </List>
            <Box px={2}>
              <GameButton
                onClick={closeDrawer}
                fullWidth
                color="error"
                variant="contained"
                sx={{
                  zIndex: 1000,
                  width: "100%",
                }}
              >
                Close
              </GameButton>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  )
}

export default LayoutDrawer
